/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassStudents401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassStudents.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedClassStudents } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedClassStudents.ts";

export const getApiV1ClassroomdisciplineSharedClassStudentsQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/class-students" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedClassStudentsQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedClassStudentsQueryKey
>;

export function getApiV1ClassroomdisciplineSharedClassStudentsQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1ClassroomdisciplineSharedClassStudentsQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassStudents401>,
    GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedClassStudents(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de turmas (opcionalmente filtradas por courseId) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-students}
 */
export function useGetApiV1ClassroomdisciplineSharedClassStudents<
  TData = GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedClassStudentsQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassStudents401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedClassStudentsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedClassStudentsQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassStudents401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
